import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/header/Header";
import { startLiveStreming, updateLiveStreming } from "../../../api/apiHandler";
import IVSBroadcastClient from "amazon-ivs-web-broadcast"; // ✅ correct import
import Swal from "sweetalert2";

const LiveStreaming = () => {
  const previewRef = useRef(null);
  const [log, setLog] = useState("Ready");
  const [channel, setChannel] = useState(null);
  const [streamKey, setStreamKey] = useState(null);
  const [ivsClient, setIvsClient] = useState(null);
  const navigate = useNavigate();

  // Logging helper
  const addLog = (...args) => {
    setLog((prev) => {
      return (
        prev +
        "\n" +
        args
          .map((a) =>
            typeof a === "object" ? JSON.stringify(a, null, 2) : String(a)
          )
          .join(" ")
      );
    });
  };

  // Attach camera/mic preview + init client
  const handlePreview = async (ingestEndpoint) => {
    try {
      const streamConfig = IVSBroadcastClient.BASIC_LANDSCAPE;

      const broadcastClient = IVSBroadcastClient.create({
        streamConfig,
        ingestEndpoint,
      });

      // Attach preview element
      broadcastClient.attachPreview(previewRef.current);

      // Get video stream
      const videoStream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: streamConfig.maxResolution.width },
          height: { ideal: streamConfig.maxResolution.height },
        },
        audio: false,
      });

      // Get audio stream
      const audioStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });

      await broadcastClient.addVideoInputDevice(videoStream, "camera1", {
        index: 0,
      });
      await broadcastClient.addAudioInputDevice(audioStream, "mic1");

      setIvsClient(broadcastClient);
      addLog("Preview ready.");
      return broadcastClient;
    } catch (err) {
      addLog("Preview failed:", err.message || String(err));
    }
  };

  // Ask backend for channel + streamKey, then preview + broadcast
  const handleStartBroadcast = async () => {
    try {
      let response = await startLiveStreming({});
      response = JSON.parse(response);

      const { streamKey, channelArn, ingestEndpoint } = response.data;
      if (!channelArn || !streamKey || !ingestEndpoint) {
        addLog("Server error:", JSON.stringify(response.data));
        return;
      }

      setChannel(channelArn);
      setStreamKey(streamKey);

      // First preview
      const broadcastClient = await handlePreview(ingestEndpoint);

      // Start broadcast
      if (broadcastClient) {
        addLog("Starting broadcast...");
        await broadcastClient.startBroadcast(streamKey);
        addLog("Broadcast started! 🎉");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Broadcast started!.",
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (err) {
      addLog("Start broadcast failed:", err.message || String(err));
    }
  };

  const handleStopBroadcast = async () => {
    if (!ivsClient) return;

    try {
      let response = await updateLiveStreming({ status: 0 });
      if (typeof response === "string") {
        try {
          response = JSON.parse(response);
        } catch {
          console.error("Failed to parse response:", response);
        }
      }

      console.log("Stop broadcast response:", response);

      if (response?.code === 200) {
        try {
          await ivsClient.stopBroadcast();
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Broadcast stopped.",
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
          addLog("Broadcast stopped.");
        } catch (err) {
          addLog(`Error stopping broadcast: ${err.message || String(err)}`);
        } finally {
          setIvsClient(null);
        }
      } else {
        addLog(
          `Stop broadcast failed: ${response?.message || "Unknown error"}`
        );
      }
    } catch (err) {
      addLog(`Stop error: ${err.message || String(err)}`);
    }
  };

  // ✅ Confirmation before closing tab/browser
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     if (ivsClient) {
  //       event.preventDefault();
  //       event.returnValue = "";
  //     }
  //   };
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  // }, [ivsClient]);

  const handleBack = async () => {
    if (ivsClient) {
      const result = await Swal.fire({
        title: "End broadcast?",
        text: "Do you want to stop the broadcast before leaving?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "End Broadcast",
        cancelButtonText: "Continue Streaming",
      });

      if (result.isConfirmed) {
        await handleStopBroadcast();
        navigate("/");
      }
    } else {
      navigate("/");
    }
  };

  return (
    <main>
      <Header />

      <section>
        <div className="container">
          <div className="meeting-room">
            <div className="row font_30 font-weight-bold">
              <h3 className="text-black px-0 font_30">Broadcast</h3>
              {/* <button className="btn btn-secondary ml-3" onClick={handleBack}>
                Back
              </button> */}
            </div>
            <div className="members-dv d-flex flex-wrap gap-2 justify-content-center">
              <div style={{ fontFamily: "system-ui, Arial", maxWidth: 900 }}>
                <div className="d-flex flex-wrap gap-2 justify-content-center my-3">
                  <button
                    className="btn px-3 text-white"
                    style={{ backgroundColor: "#216fc8", padding: "10px 0" }}
                    disabled={ivsClient}
                    onClick={handleStartBroadcast}
                  >
                    Start Broadcast
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={handleStopBroadcast}
                  >
                    Stop Broadcast
                  </button>
                </div>

                {/* Preview element */}
                <canvas
                  ref={previewRef}
                  autoPlay
                  muted
                  playsInline
                  style={{
                    width: 640,
                    height: 360,
                    background: "#222",
                    display: "block",
                    marginBottom: 8,
                  }}
                />

                {/* Logs */}
                <pre
                  style={{
                    background: "#111",
                    color: "#0f0",
                    padding: "10px",
                    borderRadius: "5px",
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {log}
                </pre>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default LiveStreaming;
